
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100"
      style={{
        backgroundImage: `url('/images/4fd1343cf746891fcdfb894aeab48409.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="absolute inset-0 bg-blue-900/40"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="text-white">Rena</span>
            <span className="text-blue-300">bach</span>
          </h1>
          
          <div className="bg-blue-600 text-white px-6 py-2 rounded-full inline-block mb-8 text-lg font-semibold">
            RED NACIONAL DE BACHILLERATOS
          </div>
          
          <p className="text-xl md:text-2xl mb-8 text-blue-50 leading-relaxed max-w-3xl mx-auto">
            Fortaleciendo vínculos entre universidades chilenas para promover la 
            <span className="font-semibold text-white"> formación integral</span> y el desarrollo del 
            <span className="font-semibold text-white"> pensamiento crítico</span> en los programas de bachillerato
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg" 
              onClick={() => scrollToSection('sobre-nosotros')}
              className="border-2 border-white text-white hover:bg-blue-700  bg-blue-600/20 backdrop-blur-sm"
            >
              <i className="ri-arrow-right-line mr-2"></i>
              Conoce Más
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => scrollToSection('contacto')}
              className="border-2 border-white text-white hover:bg-blue-700  bg-blue-600/20 backdrop-blur-sm"
            >
              <i className="ri-team-line mr-2"></i>
              Únete a la Red
            </Button>
          </div>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-300 mb-2">15+</div>
              <div className="text-blue-100">Universidades Participantes</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-300 mb-2">2024</div>
              <div className="text-blue-100">Año de Fundación</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-300 mb-2">1</div>
              <div className="text-blue-100">Primer Encuentro Nacional</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('sobre-nosotros')}
          className="w-10 h-10 rounded-full border-2 border-white/50 flex items-center justify-center text-white hover:bg-white/10 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line"></i>
        </button>
      </div>
    </section>
  );
}
